/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiTransactionSummaryByMonth
 */
export interface InternalApiTransactionSummaryByMonth {
    /**
     * 
     * @type {number}
     * @memberof InternalApiTransactionSummaryByMonth
     */
    totalAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiTransactionSummaryByMonth
     */
    startOfMonth: Date;
}

/**
 * Check if a given object implements the InternalApiTransactionSummaryByMonth interface.
 */
export function instanceOfInternalApiTransactionSummaryByMonth(value: object): value is InternalApiTransactionSummaryByMonth {
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('startOfMonth' in value) || value['startOfMonth'] === undefined) return false;
    return true;
}

export function InternalApiTransactionSummaryByMonthFromJSON(json: any): InternalApiTransactionSummaryByMonth {
    return InternalApiTransactionSummaryByMonthFromJSONTyped(json, false);
}

export function InternalApiTransactionSummaryByMonthFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionSummaryByMonth {
    if (json == null) {
        return json;
    }
    return {
        
        'totalAmount': json['totalAmount'],
        'startOfMonth': (new Date(json['startOfMonth'])),
    };
}

export function InternalApiTransactionSummaryByMonthToJSON(json: any): InternalApiTransactionSummaryByMonth {
    return InternalApiTransactionSummaryByMonthToJSONTyped(json, false);
}

export function InternalApiTransactionSummaryByMonthToJSONTyped(value?: InternalApiTransactionSummaryByMonth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalAmount': value['totalAmount'],
        'startOfMonth': value['startOfMonth'].toISOString().substring(0,10),
    };
}

